<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-body padding-top-0px margin-left-0px padding-right-0px padding-left-0px padding-bottom-0px">

        <div class="modal-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

          <div class="card" *ngIf="Categories">
            <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

              Add New Enquiry

              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card-body margin-left-0px">
              <div class="margin-left-zero p-0 margin-top-20px">
                <div class="card height-100pe">


                  <div class="" *ngIf="Categories">
                    
                    <div class="row height-100pe padding-top-10px padding-bottom-20px">
                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="individual1()" *canUserAccess="['HL_REG_3']">
                        <div class="padding-all-10px height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="individual1()">
                            <h4 class="text-align-center font-size-18px">Individual</h4>
                            <div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>


                          </div>
                        </div>
                      </div>
                      

                      <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="donor()" *canUserAccess="['HL_REG_4']">
                        <div class="padding-all-10px height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="donor()">
                            <h4 class=" text-align-center font-size-18px">Donor</h4>
                            <div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div hidden class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="couple()" *canUserAccess="['HL_REG_5']">
                        <div class="padding-all-10px height-100pe background-pay badge-cycle">
                          <div class="center-element-addnew" (click)="couple()">
                            <h4 class="text-align-center font-size-18px">Couple</h4>
                            <div class="text-align-center">
                              <i class="fas fa-user font-size-64px"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
            </div>
          </div>
          <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm" *ngIf="Individual">
            <div class="card">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Individual Enquiry

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body padding-bottom-0px">
                <div>

                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            Salutation (Name Prefix)
                          </label>
                        </div>
                        <div class="col-md-3">
                          <CodeTypeValue CodeType="NPRE" id="CurrentSavePatientInfoRequest.Salutation"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                         name="CurrentSavePatientInfoRequest.Salutation">
                          </CodeTypeValue>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Name </label>
                        </div>
                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="First Name"
                                 id="CurrentSavePatientInfoRequest.DisplayName"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                 name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #DisplayName="ngModel" required>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px">Age </label>
                        </div>
                        <div class="col-md-3">
                          <input type="number" class="form-control" placeholder="Age"
                                 id="IndividualAge"
                                 [(ngModel)]="IndividualAge" (ngModelChange)="IndividualAge = IndiNewAge($event)"
                                 name="IndividualAge" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #IndiAge="ngModel">
                          <!--<input type="text" class="form-control" placeholder="Age"
                                 id="CurrentSavePatientInfoRequest.Age"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.Age"
                                 name="CurrentSavePatientInfoRequest.Age" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #Age="ngModel">-->

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px">Contact Number </label>
                        </div>
                        <div class="col-md-3">
                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 id="CurrentSavePatientInfoRequest.Telephone1"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                 name="CurrentSavePatientInfoRequest.Telephone1"
                                 maxlength="25" minlength="1" #Telephone1="ngModel" required>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Spouse Name </label>
                        </div>
                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="Partner Name"
                                 id="CurrentSavePatientInfoRequest.PartnerName"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.PartnerName"
                                 name="CurrentSavePatientInfoRequest.PartnerName" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #PartnerName="ngModel">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px">Sex</label>
                        </div>
                        <div class="col-md-3">
                          <CodeTypeValue CodeType="Sex"
                                         id="CurrentSavePatientInfoRequest.Gender"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue=""
                                         name="CurrentSavePatientInfoRequest.Gender">
                          </CodeTypeValue>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                        </div>
                        <div class="col-md-3">
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>
                        </div>
                        <div class="col-md-3">
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line2"
                                    name="CurrentSavePatientInfoRequest.AddressLine2"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2" minlength="1" maxlength="100"
                                    #addconcerns_text2="ngModel"></textarea>
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit"
                        class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
          </form>
          <form class="form" novalidate="" (ngSubmit)="onDonor()" #f="ngForm" *ngIf="Donor">
            <div class="card">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Donor Enquiry

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body padding-bottom-0px">
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px">Donor Type</label>
                      </div>
                      <div class="col-md-3">
                        <CodeTypeValue CodeType="DONTY"
                                       id="CurrentSavePatientInfoRequest.DonorTypeName"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.DonorTypeName" SelectedValue=""
                                       name="CurrentSavePatientInfoRequest.DonorTypeName">
                        </CodeTypeValue>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">
                          Salutation (Name Prefix)
                        </label>
                      </div>
                      <div class="col-md-3">
                        <CodeTypeValue CodeType="NPRE"
                                       id="CurrentSavePatientInfoRequest.Salutation"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                       name="CurrentSavePatientInfoRequest.Salutation">
                        </CodeTypeValue>
                      </div>


                    </div>

                  </div>
                </div>
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Name </label>
                      </div>
                      <div class="col-md-3">
                        <input type="text" class="form-control" placeholder="First Name"
                               id="CurrentSavePatientInfoRequest.DisplayName"
                               [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                               name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1" #DisplayName="ngModel" required>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px">Age </label>
                      </div>
                      <div class="col-md-3">
                        <input type="number" class="form-control" placeholder="Age"
                               id="DonorAge"
                               [(ngModel)]="DonorAge" (ngModelChange)="DonorAge = DnrNewAge($event)"
                               name="DonorAge" pattern="^[\sa-zA-Z,._\-?]*$"
                               maxlength="30" minlength="1" #DnrAge="ngModel">
                        <!--<input type="text" class="form-control" placeholder="Age"
                               id="CurrentSavePatientInfoRequest.Age"
                               [(ngModel)]="CurrentSavePatientInfoRequest.Age"
                               name="CurrentSavePatientInfoRequest.Age" pattern="^[\sa-zA-Z,._\-?]*$"
                               maxlength="30" minlength="1" #Age="ngModel">-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px">Contact Number </label>
                      </div>
                      <div class="col-md-3">

                        <input type="tel" class="form-control" placeholder="Mobile Phone"
                               id="CurrentSavePatientInfoRequest.Telephone1"
                               [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                               name="CurrentSavePatientInfoRequest.Telephone1"
                               maxlength="25" minlength="1" #Telephone1="ngModel" required>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Spouse Name </label>
                      </div>
                      <div class="col-md-3">
                        <input type="text" class="form-control" placeholder="Partner Name"
                               id="CurrentSavePatientInfoRequest.PartnerName"
                               [(ngModel)]="CurrentSavePatientInfoRequest.PartnerName"
                               name="CurrentSavePatientInfoRequest.PartnerName" pattern="^[\sa-zA-Z,._\-?]*$"
                               maxlength="30" minlength="1" #PartnerName="ngModel">
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px">Address</label>
                      </div>
                      <div class="col-md-3">
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                  name="CurrentSavePatientInfoRequest.AddressLine1"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                  #addconcerns_text1="ngModel"></textarea>
                      </div>
                      <div class="col-md-3">
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line2"
                                  name="CurrentSavePatientInfoRequest.AddressLine2"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2" minlength="1" maxlength="100"
                                  #addconcerns_text2="ngModel"></textarea>
                      </div>
                    </div>


                  </div>
                </div>


              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit"
                        class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
          </form>
          <form class="form" novalidate="" (ngSubmit)="onCouple()" #f="ngForm" *ngIf="Couple">
            <div class="card top-link">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Couple Enquiry

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body margin-left-0px padding-top-0px">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-4 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-female-heading padding-right-0px ">
                          Female Registration
                        </div>

                      </div>

                    </div>
                    
                    <div class="col-md-4 padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-male-heading">
                          Male Registration
                        </div>

                      </div>

                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-top-5px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                    Salutation (Name Prefix)
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row my-profile-form margin-top-10">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Name </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px">Date of Birth  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px">Contact Number  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <CodeTypeValue CodeType="FSAL"
                                                 id="CurrentSavePatientInfoRequest.Salutation"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                 name="CurrentSavePatientInfoRequest.Salutation">
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <input type="text" class="form-control" placeholder="First Name"
                                         id="CurrentSavePatientInfoRequest.DisplayName"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                         name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                         maxlength="30" minlength="1" #DisplayName="ngModel">                                  
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <input type="number" class="form-control" placeholder="Female Age"
                                         id="FemaleAge"
                                         [(ngModel)]="FemaleAge" (ngModelChange)="FemaleAge = FNewAge($event)"
                                         name="FemaleAge" pattern="^[\sa-zA-Z,._\-?]*$"
                                         maxlength="30" minlength="1" #FAge="ngModel">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">                                  
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                         name="CurrentSavePatientInfoRequest.Telephone1"
                                         maxlength="25" minlength="1" #Telephone2="ngModel">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <CodeTypeValue CodeType="MSAL"
                                                 id="CurrentSavePatientInfoRequest.SalutationMale"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.SalutationMale" SelectedValue=""
                                                 name="CurrentSavePatientInfoRequest.SalutationMale" required>
                                  </CodeTypeValue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <input type="text" class="form-control" placeholder="First Name"
                                         id="CurrentSavePatientInfoRequest.DisplayNameMale"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.DisplayNameMale"
                                         name="CurrentSavePatientInfoRequest.DisplayNameMale" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1" #DisplayName="ngModel">                                  
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <input type="number" class="form-control" placeholder="Male Age"
                                         id="Age"
                                         [(ngModel)]="Age" (ngModelChange)="Age = NewAge($event)"
                                         name="Age" pattern="^[\sa-zA-Z,._\-?]*$"
                                         maxlength="30" minlength="1" #MAge="ngModel">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">                                  
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         name="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         maxlength="25" minlength="1" #Telephone1="ngModel">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-10 background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-top-10 margin-left-0px">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                        </div>
                        <div class="col-md-4">                          
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>                          
                        </div>
                        <div class="col-md-4">                          
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line2"
                                    name="CurrentSavePatientInfoRequest.AddressLine2"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2" minlength="1" maxlength="100"
                                    #addconcerns_text2="ngModel"></textarea>                          
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit"
                        class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
            <div class="card top-link2">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Couple

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body margin-left-0px padding-top-0px">
                <div class="col-md-12 col-12">
                  <div class="row">

                    <div class="col-md-4 col-12 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-female-heading padding-right-0px padding-bottom-0px">
                          Female Registration
                        </div>

                      </div>
                    </div>
                    
                  </div>
                  <div class="row">
                    <div class="col-md-3 col-12">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-top-5px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                    <span>*</span>Salutation (Name Prefix)


                                  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-md-12 col-12">

                                      <CodeTypeValue CodeType="FSAL"
                                                     id="CurrentSavePatientInfoRequest.Salutation"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                     name="CurrentSavePatientInfoRequest.Salutation">
                                      </CodeTypeValue>


                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row my-profile-form margin-top-10">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right ">
                                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                </div>


                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 col-12">
                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayName"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                             name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                             maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right ">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 col-12 text-align-right">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dps" [(ngModel)]="FemaleDateofBirth" ngbDatepicker #d1="ngbDatepicker" #DOB="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 col-12 text-align-right">
                                      
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.Telephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                             name="CurrentSavePatientInfoRequest.Telephone1"
                                             maxlength="25" minlength="1" #Telephone1="ngModel">
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="row">

                    <div class="col-md-4 col-12 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-male-heading padding-right-0px padding-bottom-0px">
                          Male Registration
                        </div>

                      </div>

                    </div>
                    
                  </div>
                  <div class="row">
                    <div class="col-md-3 col-12">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-top-5px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                    <span>*</span>Salutation (Name Prefix)


                                  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-md-12">

                                      <CodeTypeValue CodeType="MSAL"
                                                     id="CurrentSavePatientInfoRequest.SalutationMale"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.SalutationMale" SelectedValue=""
                                                     name="CurrentSavePatientInfoRequest.SalutationMale">
                                      </CodeTypeValue>



                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row my-profile-form margin-top-10">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                </div>


                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayNameMale"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayNameMale"
                                             name="CurrentSavePatientInfoRequest.DisplayNameMale" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 text-align-right">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp2" [(ngModel)]="DateOfBirth" ngbDatepicker #d2="ngbDatepicker" #DOB="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d2.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>

                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 text-align-right">
                                      
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             name="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             maxlength="25" minlength="1" #Telephone1="ngModel">
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row margin-top-10 background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-top-10 margin-left-0px">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                        </div>
                        <div class="col-md-6">
                          
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"  minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-left-0px">
                        <div class=" col-md-3 text-align-right padding-right-0px">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Wedding Anniversary</label>
                        </div>
                        <div class="col-md-3">
                          
                          <div class="date-form">
                            <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp3" [(ngModel)]="WeddingAn" ngbDatepicker #d4="ngbDatepicker" #DOB="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                            <a (click)="d4.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit"
                        class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</div>

